import React, { PureComponent } from "react";
import WelcomeLayout from "../../layouts/welcome";

class TeamReportsSection6Step1 extends PureComponent {
  get right_content() {
    return <span>How risky is your capital?</span>;
  }

  render() {
    return (
      <WelcomeLayout
        title="Financing Analysis"
        right_content={this.right_content}
      />
    );
  }
}

export default TeamReportsSection6Step1;



// WEBPACK FOOTER //
// ./src/components/team-reports/steps/section-6/step-1.js